import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function getImageUrl(url, fallback = '') {
  if (!url) return fallback;
  if (typeof url !== 'string') return fallback;
  if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('data:') || url.startsWith('blob:')) {
    return url;
  }
  const cleanPath = url.startsWith('/') ? url : `/${url}`;
  const backend = process.env.REACT_APP_BACKEND_URL || '';
  if (backend && !backend.startsWith('/')) {
    return `${backend.replace(/\/+$/, '')}${cleanPath}`;
  }
  return cleanPath;
}

export function getFileUrl(url, fallback = '') {
  return getImageUrl(url, fallback);
}
